import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
	name: 'translateExt',
})
export class TranslateExtPipe implements PipeTransform {
	constructor(private translate: TranslateService) {}

	transform(value: string, options: {separator?: string; joiner?: string} = {}): string {
		const {separator = ',', joiner = ' '} = options;
		const values = this.splitValue(value, separator);
		return values.map(item => this.translate.instant(item)).join(joiner);
	}

	private splitValue(value: string, separator: string): string[] {
		return value
			.split(separator)
			.map(item => item.trim())
			.filter(Boolean);
	}
}
